import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@splidejs/splide/dist/css/splide.min.css';
import '@/assets/css/scroll-reveal.scss';
import moment from 'moment';
import myAxios from '@/assets/js/myAxios';
import Vab from '@/utils/vab'
import scrollReveal from '@/directives/scrollReveal'


Vue.use(Vab)
Vue.use(ElementUI);
Vue.directive('scroll-reveal', scrollReveal);

export const EventBus = new Vue();
Vue.prototype.$EventBus = EventBus;

Vue.config.productionTip = false
Vue.prototype.$moment = moment;
Vue.prototype.$http = myAxios;
Vue.prototype.$baseMessage = (message, type) => {
  ElementUI.Message({
    message: message,
    type: type
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
